module.exports = __webpack_public_path__ + "img/53.2.TN.4330495f.png";